import React, {useState,useEffect} from 'react'
import './style.css'
import { Link } from "react-router-dom";
import { SingleLineInput } from '../components/SingleLineInput/SingleLineInput';
import { usernameInfo, repoInfo, authInfo,pathInfo } from '../components/ToolTip/toolTipData';
import { TextAreaInput } from '../components/TextAreaInput/TextAreaInput';
import { fetchFromGithub } from '../utils/fetchFunctions';
import { DropDownMenu } from '../components/DropDownMenu/DropDownMenu';
import { getAllRepos } from '../utils/indexedDB';
export const AddEditMapFromGitHub = () =>{
    const [username,setUsername] = useState("")
    const [reponame,setReponame] = useState("")
    const [path,setPath] = useState("")
    const [auth,setAuth] = useState("")
    const [ready,setReady] = useState(false)
    const [reqData,setReqData] = useState({})
    const [repoData,setRepoData] = useState()
    const [repoList,setRepoList] = useState()
    const patPlaceholderString = " This space can be left blank if no authentication is needed.  Your personal access token will be deleted after the map is fetched.  Your other data will remain in local storage until you delete the map.  You will need to re-enter your personal access token to update the map in the future."
    useEffect(()=>{
        if(username!==""&&reponame!==""&&path!=="") setReady(true)
        else setReady(false)
        
        const data = {username:username,repo:reponame,path:path,auth:auth}
        setReqData(data)
    },[username,reponame,path,auth])
    useEffect(()=>{
        getAllRepos(setRepoList)
    },[])

    useEffect(()=>{
        if(repoData){
            if(repoData.username&&repoData.repo){
            document.querySelector('input#username').value = repoData.username
            setUsername(repoData.username)
            document.querySelector('input#repo').value = repoData.repo
            setReponame(repoData.repo)
            document.querySelector('input#path').value = repoData.path
            setPath(repoData.path)
            }
        }
        
    },[repoData])

    return(
        <div className="bodyContainer">
            <div className="addEditHeader">
            <div>Add Map From GitHub</div>
                <Link to="/mymaps">Cancel</Link>
            </div>
            <DropDownMenu placeholder="Select a repo" setData={setRepoData} list={repoList} subject='repos'/>
            <SingleLineInput title="Owner Username" id='username' toolTipInfo={usernameInfo} setState={setUsername} placeholder="(REQUIRED)"/>
            <SingleLineInput title="Repo Name" id='repo' toolTipInfo={repoInfo} setState={setReponame} placeholder="(REQUIRED)"/>
            <SingleLineInput title="Path" id='path' toolTipInfo={pathInfo} setState={setPath} placeholder="(REQUIRED)"/>
            <TextAreaInput title="Personal Access Token" toolTipInfo={authInfo} setState={setAuth} placeholder={patPlaceholderString}/>
            <button onClick={()=>fetchFromGithub(reqData)} className={`addEdit ${ready?"":"disabled"}`}>Get Map</button>
        </div> 
    )
   
}